import type { Reducer } from 'redux';

import { LOGOUT_SUCCESS } from 'features/auth/redux/types';
import { SubscriptionPlansData } from 'features/subscription/redux/action';
import { SET_IS_LOADING, GET_PLANS_DETAILS, SET_SUBSCRIPTION_PLAN } from 'features/subscription/redux/types';
import { PlansData } from 'features/subscription/ts/SubscriptionPlans';

export interface SubscriptionPlans {
  allSubscriptionData: PlansData[];
  isLoading: boolean;
  selectedPlans: string;
}

export const INITIAL_STATE: SubscriptionPlans = {
  allSubscriptionData: [],
  isLoading: false,
  selectedPlans: 'year',
};

const subscriptionReducer: Reducer<SubscriptionPlans, SubscriptionPlansData> = (
  state = INITIAL_STATE,
  action
): SubscriptionPlans => {
  switch (action.type) {
    case LOGOUT_SUCCESS:
      return INITIAL_STATE;
    case SET_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case GET_PLANS_DETAILS:
      return {
        ...state,
        allSubscriptionData: action.payload,
      };
    case SET_SUBSCRIPTION_PLAN:
      return {
        ...state,
        selectedPlans: action.payload,
      };
    default: {
      return state;
    }
  }
};

export default subscriptionReducer;
